// src/modules/gerenciador/AvaliacaoDashboard.js
import React, { useState, useEffect, useMemo } from 'react';
import { db, paths } from '../../firebase/config';
import { collection, query, where, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, onSnapshot, writeBatch, getDocs } from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';

// ==================== ÍCONES ====================
const ChartIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" /></svg>;
const UserGroupIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const PlusIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;
const MinusIcon = ({ className = "w-5 h-5" }) => <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" /></svg>;
const SearchIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>;
const PrinterIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>;
const TrashIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const RefreshIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.926 8.926 0 0112 21a9 9 0 01-5.6-3.2m15.356-2A8.926 8.926 0 0012 3a9 9 0 00-5.6 3.2" /></svg>;
const LockClosedIcon = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>;
const DotsIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 12h.01M12 12h.01M19 12h.01M6 12a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;

export const AvaliacaoDashboard = () => {
    const { userProfile } = useAuth();
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('resultados');

    const [selectedPelotaoTab, setSelectedPelotaoTab] = useState('');
    const [filterProfessor, setFilterProfessor] = useState('');
    
    const [selectedCursoResult, setSelectedCursoResult] = useState('');
    const [selectedTurmaResult, setSelectedTurmaResult] = useState('');
    
    // Controles de Acordeão e Modal de Imagem
    const [expandedTeacherId, setExpandedTeacherId] = useState(null);
    const [expandedAssessmentId, setExpandedAssessmentId] = useState(null);
    const [expandedImage, setExpandedImage] = useState(null);

    // Dados
    const [ciclos, setCiclos] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [respostas, setRespostas] = useState([]);
    const [alunos, setAlunos] = useState([]);

    // Modal
    const [showModal, setShowModal] = useState(false);
    const [formCiclo, setFormCiclo] = useState({ titulo: '', curso_nome: '', turma_id: '', professores_ids: [], ativo: true });
    const [processing, setProcessing] = useState(false);
    const [actionMenuOpenId, setActionMenuOpenId] = useState(null);

    // ==================== FILTROS DE CURSO E PROFESSORES ====================
    const cursosDisponiveis = useMemo(() => {
        const cursos = new Set();
        professores.forEach(prof => {
            if (prof.aulas && Array.isArray(prof.aulas)) {
                prof.aulas.forEach(aula => {
                    if (aula.curso_nome) cursos.add(aula.curso_nome);
                });
            }
        });
        return Array.from(cursos).sort();
    }, [professores]);

    const professoresFiltrados = useMemo(() => {
        if (!formCiclo.curso_nome) return [];
        return professores.filter(p => 
            p.aulas && p.aulas.some(aula => aula.curso_nome === formCiclo.curso_nome)
        );
    }, [professores, formCiclo.curso_nome]);

    const profsOcupadosNoCurso = useMemo(() => {
        const ocupados = new Set();
        ciclos.filter(c => c.ativo).forEach(ciclo => {
            if (ciclo.professores_ids) {
                ciclo.professores_ids.forEach(id => {
                    if (ciclo.curso_nome) ocupados.add(`${id}_${ciclo.curso_nome}`);
                    else ocupados.add(`${id}_legacy`);
                });
            }
        });
        return ocupados;
    }, [ciclos]);

    // ==================== MEMOS DE RESULTADOS E PENDÊNCIAS ====================
    const ciclosAtivos = useMemo(() => ciclos.filter(c => c.ativo).length, [ciclos]);

    const pendenciasAgrupadas = useMemo(() => {
        const grupos = {};
        const ciclosRelevantes = ciclos.filter(c => c.ativo);
        
        // OTIMIZAÇÃO DE PERFORMANCE (O(1)): Mapa rápido de respostas ao invés de filter dentro de loop
        const mapRespostas = {};
        respostas.forEach(r => {
            if (!mapRespostas[r.ciclo_id]) mapRespostas[r.ciclo_id] = {};
            mapRespostas[r.ciclo_id][r.cadete_id] = (mapRespostas[r.ciclo_id][r.cadete_id] || 0) + 1;
        });

        ciclosRelevantes.forEach(ciclo => {
            const turmaNome = ciclo.turma_nome || "Turma Desconhecida";
            const alunosDaTurma = alunos.filter(a => a.turma_id === ciclo.turma_id);
            const totalProfessores = ciclo.professores_ids ? ciclo.professores_ids.length : 0;
            
            if (totalProfessores === 0) return;

            const cicloRespostas = mapRespostas[ciclo.id] || {};

            alunosDaTurma.forEach(aluno => {
                const qtdFeitas = cicloRespostas[aluno.id] || 0;
                if (qtdFeitas < totalProfessores) {
                    const pelotaoNome = aluno.pelotao_nome || "Sem Pelotão";
                    if (!grupos[turmaNome]) grupos[turmaNome] = {};
                    if (!grupos[turmaNome][pelotaoNome]) grupos[turmaNome][pelotaoNome] = [];
                    
                    grupos[turmaNome][pelotaoNome].push({
                        id: aluno.id, nome: aluno.nome, re: aluno.matricula || 'N/D',
                        faltam: totalProfessores - qtdFeitas, total: totalProfessores
                    });
                }
            });
        });
        
        const ordenado = {};
        Object.keys(grupos).sort().forEach(turma => {
            ordenado[turma] = {};
            Object.keys(grupos[turma]).sort().forEach(pelotao => {
                ordenado[turma][pelotao] = grupos[turma][pelotao].sort((a,b) => a.nome.localeCompare(b.nome));
            });
        });
        return ordenado;
    }, [ciclos, alunos, respostas]);

    const totalPendentes = useMemo(() => {
        return Object.values(pendenciasAgrupadas).reduce((acc, pelotoesObj) =>
            acc + Object.values(pelotoesObj).reduce((a, lista) => a + lista.length, 0), 0);
    }, [pendenciasAgrupadas]);

    // --------- NOVOS MEMOS PARA ABA DE RESULTADOS ---------
    const respostasEnriquecidas = useMemo(() => {
        return respostas.map(r => {
            const ciclo = ciclos.find(c => c.id === r.ciclo_id);
            return {
                ...r,
                curso_nome: ciclo?.curso_nome || 'Sem Curso',
                turma_nome: ciclo?.turma_nome || 'Sem Turma',
            };
        });
    }, [respostas, ciclos]);

    const cursosComResultados = useMemo(() => {
        const cursos = new Set(ciclos.filter(c => c.curso_nome).map(c => c.curso_nome));
        return Array.from(cursos).sort();
    }, [ciclos]);

    useEffect(() => {
        if (cursosComResultados.length > 0 && !selectedCursoResult) {
            setSelectedCursoResult(cursosComResultados[0]);
        }
    }, [cursosComResultados, selectedCursoResult]);

    const turmasDoCurso = useMemo(() => {
        if (!selectedCursoResult) return [];
        const t = new Set();
        ciclos.filter(c => c.curso_nome === selectedCursoResult).forEach(c => {
            if (c.turma_nome) t.add(c.turma_nome);
        });
        return Array.from(t).sort();
    }, [ciclos, selectedCursoResult]);

    const resultadosCalculados = useMemo(() => {
        if (!selectedCursoResult) return [];

        let filtradas = respostasEnriquecidas.filter(r => r.curso_nome === selectedCursoResult);
        
        if (selectedTurmaResult) {
            filtradas = filtradas.filter(r => r.turma_nome === selectedTurmaResult);
        }

        // OTIMIZAÇÃO: Mapa de professores para consulta rápida
        const mapProfs = {};
        professores.forEach(p => { mapProfs[p.id] = p; });

        const dados = {};
        filtradas.forEach(resp => {
            if (!dados[resp.professor_id]) {
                const prof = mapProfs[resp.professor_id];
                const materias = prof?.aulas
                    ?.filter(a => a.curso_nome === selectedCursoResult)
                    .map(a => a.materia_nome)
                    .join(' / ') || 'N/D';

                dados[resp.professor_id] = { 
                    id: resp.professor_id,
                    nome: prof?.nome_completo || 'Desconhecido', 
                    posto: prof?.posto || '', 
                    materia: materias,
                    foto: prof?.foto || prof?.fotoUrl || prof?.foto_url || prof?.url_foto || null,
                    somaGeral: 0, 
                    qtdAvaliacoes: 0,
                    avaliacoes: [] 
                };
            }
            if (resp.nota_geral) {
                dados[resp.professor_id].somaGeral += Number(resp.nota_geral);
                dados[resp.professor_id].qtdAvaliacoes += 1;
                dados[resp.professor_id].avaliacoes.push(resp);
            }
        });
        
        let lista = Object.values(dados)
            .map(d => {
                const avaliacoesOrdenadas = d.avaliacoes.sort((a, b) => Number(b.nota_geral) - Number(a.nota_geral));
                return { 
                    ...d, 
                    avaliacoes: avaliacoesOrdenadas,
                    mediaFinal: d.qtdAvaliacoes > 0 ? (d.somaGeral / d.qtdAvaliacoes).toFixed(2) : 0 
                };
            })
            .sort((a,b) => b.mediaFinal - a.mediaFinal);

        if (filterProfessor) lista = lista.filter(d => d.nome.toLowerCase().includes(filterProfessor.toLowerCase()));
        return lista;
    }, [respostasEnriquecidas, professores, selectedCursoResult, selectedTurmaResult, filterProfessor]);

    const mediaGeral = useMemo(() => {
        if (resultadosCalculados.length === 0) return '0.00';
        return (resultadosCalculados.reduce((acc, r) => acc + parseFloat(r.mediaFinal), 0) / resultadosCalculados.length).toFixed(2);
    }, [resultadosCalculados]);

    // ==================== USEEFFECTS OTIMIZADOS ====================
    
    // 1. Dados Base Fixos (Pequenos)
    useEffect(() => {
        setLoading(true);
        const unsubCiclos = onSnapshot(collection(db, paths.avaliacoesCiclos), snap => setCiclos(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubTurmas = onSnapshot(collection(db, paths.turmas), snap => setTurmas(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        const unsubProfs = onSnapshot(collection(db, paths.professores), snap => setProfessores(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
        
        setLoading(false);
        return () => { unsubCiclos(); unsubTurmas(); unsubProfs(); };
    }, []);

    // 2. Respostas (GIGANTE) - Lazy Loading: Só carrega nas abas que precisam
    useEffect(() => {
        if (activeTab !== 'resultados' && activeTab !== 'pendencias') return;
        
        const unsubRespostas = onSnapshot(collection(db, paths.avaliacoesRespostas), snap => {
            setRespostas(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        
        return () => unsubRespostas();
    }, [activeTab]);

    // 3. Alunos (GRANDE) - Lazy Loading: Só carrega na aba de pendências
    useEffect(() => {
        if (activeTab !== 'pendencias') return;
        
        const qAlunos = query(collection(db, paths.users), where("nivel", "in", ["cadete", "cadete_academico", "escalante"]));
        const unsubAlunos = onSnapshot(qAlunos, snap => {
            setAlunos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        
        return () => unsubAlunos();
    }, [activeTab]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.action-menu-container')) setActionMenuOpenId(null);
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    // ==================== HANDLERS ====================
    const handleCreateCiclo = async (e) => {
        if (!formCiclo.turma_id || formCiclo.professores_ids.length === 0) return alert("Selecione a turma e pelo menos um professor.");
        setProcessing(true);
        try {
            const turmaNome = turmas.find(t => t.id === formCiclo.turma_id)?.nome;
            await addDoc(collection(db, paths.avaliacoesCiclos), { ...formCiclo, turma_nome: turmaNome, criado_em: serverTimestamp() });
            await logAuditoria(userProfile, "Criou Ciclo de Avaliação", { titulo: formCiclo.titulo, turma: turmaNome });
            setShowModal(false);
            setFormCiclo({ titulo: '', curso_nome: '', turma_id: '', professores_ids: [], ativo: true });
        } catch (err) { alert("Erro: " + err.message); } finally { setProcessing(false); }
    };

    const handleToggleCiclo = async (ciclo) => {
        const novoStatus = !ciclo.ativo;
        if (novoStatus) {
            const ciclosAtivos = ciclos.filter(c => c.ativo && c.id !== ciclo.id);
            const professoresComConflito = [];

            ciclo.professores_ids?.forEach(profId => {
                const conflito = ciclosAtivos.find(c => 
                    c.professores_ids?.includes(profId) && 
                    (!c.curso_nome || !ciclo.curso_nome || c.curso_nome === ciclo.curso_nome)
                );
                
                if (conflito) {
                    const prof = professores.find(p => p.id === profId);
                    if (prof && !professoresComConflito.includes(prof.nome_completo)) {
                        professoresComConflito.push(prof.nome_completo);
                    }
                }
            });

            if (professoresComConflito.length > 0) {
                return alert(`Não é possível reabrir este ciclo.\n\nOs seguintes professores já possuem avaliações abertas para este curso:\n- ${professoresComConflito.join('\n- ')}\n\nEncerre os ciclos ativos primeiro.`);
            }
        }
        if (!window.confirm(`Deseja ${novoStatus ? 'REABRIR' : 'ENCERRAR'} este ciclo?`)) return;
        await updateDoc(doc(db, paths.avaliacoesCiclos, ciclo.id), { ativo: novoStatus });
    };

    const handleDeleteCiclo = async (ciclo) => {
        if (!window.confirm(`ATENÇÃO: Excluir o ciclo "${ciclo.titulo}"?`)) return;
        setProcessing(true);
        try {
            await deleteDoc(doc(db, paths.avaliacoesCiclos, ciclo.id));
            const q = query(collection(db, paths.avaliacoesRespostas), where("ciclo_id", "==", ciclo.id));
            const snap = await getDocs(q);
            const batch = writeBatch(db);
            snap.docs.forEach(d => batch.delete(d.ref));
            await batch.commit();
            await logAuditoria(userProfile, "Excluiu Ciclo de Avaliação", { titulo: ciclo.titulo });
        } catch (err) { alert("Erro: " + err.message); } finally { setProcessing(false); }
    };

    const toggleActionMenu = (id, e) => {
        e.stopPropagation();
        setActionMenuOpenId(actionMenuOpenId === id ? null : id);
    };

    const handlePrintPendencias = (turma, pelotao, lista) => {
        const win = window.open('', '_blank');
        const html = `
            <html>
                <head>
                    <title>Pendências - ${turma} - ${pelotao}</title>
                    <style>
                        body { font-family: sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f4f4f4; }
                    </style>
                </head>
                <body>
                    <h2>Relatório de Pendências</h2>
                    <p><strong>Turma:</strong> ${turma} | <strong>Pelotão:</strong> ${pelotao}</p>
                    <table>
                        <thead>
                            <tr><th>RE</th><th>Cadete</th><th>Avaliações Pendentes</th></tr>
                        </thead>
                        <tbody>
                            ${lista.map(a => `<tr><td>${a.re}</td><td>${a.nome}</td><td>${a.faltam} / ${a.total}</td></tr>`).join('')}
                        </tbody>
                    </table>
                    <script>window.print();</script>
                </body>
            </html>
        `;
        win.document.write(html); win.document.close();
    };

    const toggleTeacherAccordion = (id) => {
        setExpandedTeacherId(expandedTeacherId === id ? null : id);
        setExpandedAssessmentId(null); 
    };

    const toggleAssessmentAccordion = (id, e) => {
        e.stopPropagation(); 
        setExpandedAssessmentId(expandedAssessmentId === id ? null : id);
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div className="min-h-screen bg-gray-50">
            {/* HEADER + TABS PILL */}
            <header className="bg-white border-b shadow-sm">
                <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" className="h-12 w-12" />
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">Avaliação de Corpo Docente</h1>
                            <p className="text-sm text-gray-500">Gerenciamento de ciclos, resultados e pendências</p>
                        </div>
                    </div>

                    <div className="flex bg-gray-100 rounded-3xl p-1">
                        {['ciclos', 'resultados', 'pendencias'].map(t => (
                            <button key={t} onClick={() => setActiveTab(t)}
                                className={`px-8 py-2.5 rounded-3xl text-sm font-semibold transition-all ${activeTab === t ? 'bg-blue-600 text-white shadow' : 'text-gray-600 hover:bg-gray-200'}`}>
                                {t === 'ciclos' ? 'Ciclos' : t === 'resultados' ? 'Resultados' : 'Pendências'}
                            </button>
                        ))}
                    </div>
                </div>
            </header>

            <div className="max-w-7xl mx-auto px-6 py-8">
                {/* ====================== ABA CICLOS ====================== */}
                {activeTab === 'ciclos' && (
                    <div className="bg-white rounded-3xl shadow-xl p-8">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-2xl font-bold">Ciclos de Avaliação</h3>
                            <Button onClick={() => setShowModal(true)} variant="success" className="flex items-center gap-2">
                                <PlusIcon /> Novo Ciclo
                            </Button>
                        </div>
                        <div className="rounded-2xl border border-gray-100 bg-white">
                            <table className="min-w-full text-sm">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-4 text-left font-semibold text-gray-500 uppercase tracking-wider rounded-tl-xl">Título</th>
                                        <th className="px-6 py-4 text-left font-semibold text-gray-500 uppercase tracking-wider">Turma Alvo</th>
                                        <th className="px-6 py-4 text-left font-semibold text-gray-500 uppercase tracking-wider">Curso</th>
                                        <th className="px-6 py-4 text-left font-semibold text-gray-500 uppercase tracking-wider">Professores</th>
                                        <th className="px-6 py-4 text-left font-semibold text-gray-500 uppercase tracking-wider">Status</th>
                                        <th className="px-6 py-4 text-right rounded-tr-xl">Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 bg-white">
                                    {ciclos.map(c => (
                                        <tr key={c.id} className={`hover:bg-gray-50 transition-colors ${actionMenuOpenId === c.id ? 'relative z-50' : ''}`}>
                                            <td className="px-6 py-4 font-bold text-gray-900">{c.titulo}</td>
                                            <td className="px-6 py-4 text-gray-700">{c.turma_nome}</td>
                                            <td className="px-6 py-4 text-gray-500">{c.curso_nome || 'N/D'}</td>
                                            <td className="px-6 py-4 font-medium text-gray-700">{c.professores_ids?.length || 0} profs</td>
                                            <td className="px-6 py-4">
                                                <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${c.ativo ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                                    {c.ativo ? 'ABERTO' : 'ENCERRADO'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 text-right relative action-menu-container">
                                                <button onClick={(e) => toggleActionMenu(c.id, e)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                                                    <DotsIcon />
                                                </button>
                                                {actionMenuOpenId === c.id && (
                                                    <div className="absolute right-8 top-10 w-48 bg-white rounded-xl shadow-[0_5px_20px_-3px_rgba(0,0,0,0.15)] border border-gray-200 z-[999] overflow-hidden">
                                                        <button onClick={() => { handleToggleCiclo(c); setActionMenuOpenId(null); }} className="w-full text-left px-4 py-3 hover:bg-gray-50 flex items-center gap-2 text-sm font-medium text-gray-700">
                                                            {c.ativo ? <LockClosedIcon /> : <RefreshIcon />} {c.ativo ? 'Encerrar Ciclo' : 'Reabrir Ciclo'}
                                                        </button>
                                                        <button onClick={() => { handleDeleteCiclo(c); setActionMenuOpenId(null); }} className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 flex items-center gap-2 border-t text-sm font-medium">
                                                            <TrashIcon /> Excluir Ciclo
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* ====================== ABA RESULTADOS ====================== */}
                {activeTab === 'resultados' && (
                    <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8">
                        
                        {/* 1. Abas de Filtro de Cursos */}
                        {cursosComResultados.length > 0 && (
                            <div className="flex flex-wrap gap-2 mb-6 border-b pb-4">
                                {cursosComResultados.map(curso => (
                                    <button
                                        key={curso}
                                        onClick={() => {
                                            setSelectedCursoResult(curso);
                                            setSelectedTurmaResult(''); 
                                            setExpandedTeacherId(null);
                                            setExpandedAssessmentId(null);
                                        }}
                                        className={`px-6 py-2 rounded-full text-sm font-bold transition-all ${selectedCursoResult === curso ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                                    >
                                        {curso}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* 2. Cards Compactos */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                            <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl p-5">
                                <p className="text-xs text-blue-600 font-bold uppercase tracking-wider">Professores Avaliados</p>
                                <p className="text-4xl font-black text-blue-700 mt-1">{resultadosCalculados.length}</p>
                            </div>
                            <div className="bg-gradient-to-br from-emerald-50 to-white border border-emerald-100 rounded-xl p-5">
                                <p className="text-xs text-emerald-600 font-bold uppercase tracking-wider">Média Geral do Curso</p>
                                <p className="text-4xl font-black text-emerald-700 mt-1">{mediaGeral}</p>
                            </div>
                            <div className="bg-gradient-to-br from-amber-50 to-white border border-amber-100 rounded-xl p-5">
                                <p className="text-xs text-amber-600 font-bold uppercase tracking-wider">Melhor Nota</p>
                                <p className="text-4xl font-black text-amber-700 mt-1">{resultadosCalculados[0]?.mediaFinal || '—'}</p>
                            </div>
                        </div>

                        {/* 3. Título + Filtro de Turma + Busca */}
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 gap-4 bg-gray-50 p-4 rounded-2xl border border-gray-100">
                            <div className="flex items-center gap-3">
                                <ChartIcon />
                                <h3 className="text-xl font-bold text-gray-900">Desempenho Docente</h3>
                            </div>
                            
                            <div className="flex flex-col sm:flex-row w-full lg:w-auto gap-3">
                                <select 
                                    value={selectedTurmaResult} 
                                    onChange={e => { 
                                        setSelectedTurmaResult(e.target.value); 
                                        setExpandedTeacherId(null); 
                                        setExpandedAssessmentId(null);
                                    }}
                                    className="h-11 px-4 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm font-medium text-gray-700 min-w-[160px]"
                                >
                                    <option value="">Todas as Turmas</option>
                                    {turmasDoCurso.map(t => <option key={t} value={t}>{t}</option>)}
                                </select>

                                <div className="relative w-full sm:w-64 h-11">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="text-gray-400 w-5 h-5" />
                                    </div>
                                    <input type="text" placeholder="Buscar professor..." value={filterProfessor} onChange={e => setFilterProfessor(e.target.value)}
                                        className="h-full w-full pl-10 pr-4 text-sm bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500" />
                                </div>
                            </div>
                        </div>

                        {/* 4. Tabela Acordeão */}
                        <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                            <table className="min-w-full text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="px-4 py-3 w-12 text-center"></th>
                                        <th className="px-5 py-3 text-left font-bold text-gray-600 uppercase tracking-wider text-xs">Professor</th>
                                        <th className="px-5 py-3 text-left font-bold text-gray-600 uppercase tracking-wider text-xs">Matéria(s)</th>
                                        <th className="px-5 py-3 text-center font-bold text-gray-600 uppercase tracking-wider text-xs">Avaliações</th>
                                        <th className="px-5 py-3 text-center font-bold text-gray-600 uppercase tracking-wider text-xs">Média</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 bg-white">
                                    {resultadosCalculados.length > 0 ? resultadosCalculados.map((res) => (
                                        <React.Fragment key={res.id}>
                                            <tr 
                                                className={`transition-colors cursor-pointer ${expandedTeacherId === res.id ? 'bg-blue-50/50' : 'hover:bg-gray-50'}`} 
                                                onClick={() => toggleTeacherAccordion(res.id)}
                                            >
                                                <td className="px-4 py-3 text-center">
                                                    <button className="p-1 rounded-full bg-white border shadow-sm text-gray-500 hover:text-blue-600 transition-colors focus:outline-none">
                                                        {expandedTeacherId === res.id ? <MinusIcon /> : <PlusIcon />}
                                                    </button>
                                                </td>
                                                <td className="px-5 py-3">
                                                    <div className="flex items-center gap-3">
                                                        {res.foto ? (
                                                            <img 
                                                                src={res.foto} 
                                                                alt={res.nome} 
                                                                className="w-10 h-10 rounded-full object-cover border border-gray-200 shadow-sm cursor-pointer hover:ring-2 hover:ring-blue-400 transition-all" 
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); 
                                                                    setExpandedImage(res.foto);
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center border border-blue-200 shadow-sm">
                                                                <UserGroupIcon className="w-5 h-5 text-blue-500" />
                                                            </div>
                                                        )}
                                                        <div>
                                                            <div className="font-bold text-gray-900">{res.nome}</div>
                                                            <div className="text-xs text-gray-500">{res.posto}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-5 py-3 text-gray-700 font-medium">{res.materia}</td>
                                                <td className="px-5 py-3 text-center font-semibold text-gray-600">{res.qtdAvaliacoes}</td>
                                                <td className="px-5 py-3 text-center">
                                                    <span className={`px-4 py-1.5 text-sm font-bold rounded-full ${parseFloat(res.mediaFinal) >= 9 ? 'bg-emerald-100 text-emerald-800' : parseFloat(res.mediaFinal) >= 7 ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'}`}>
                                                        {res.mediaFinal}
                                                    </span>
                                                </td>
                                            </tr>

                                            {/* Detalhamento do Acordeão do Professor */}
                                            {expandedTeacherId === res.id && (
                                                <tr className="bg-gray-50 border-b border-gray-200">
                                                    <td colSpan={5} className="p-0">
                                                        <div className="px-6 md:px-10 py-6 border-l-4 border-blue-500 flex flex-col gap-6">
                                                            <div>
                                                                <h4 className="text-sm font-bold text-gray-700 mb-4 uppercase tracking-wider">Avaliações Recebidas ({res.qtdAvaliacoes})</h4>
                                                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
                                                                    
                                                                    {/* Cartões de Avaliação Individual */}
                                                                    {res.avaliacoes.map((av, idx) => (
                                                                        <div 
                                                                            key={av.id || idx} 
                                                                            onClick={(e) => toggleAssessmentAccordion(av.id || idx, e)}
                                                                            className={`bg-white p-4 rounded-xl border shadow-sm flex flex-col justify-between cursor-pointer transition-colors ${expandedAssessmentId === (av.id || idx) ? 'border-blue-400 ring-1 ring-blue-100' : 'border-gray-200 hover:border-blue-300'}`}
                                                                        >
                                                                            <div className="flex justify-between items-center">
                                                                                <span className="text-xs font-bold text-gray-500 flex items-center gap-1">
                                                                                    {expandedAssessmentId === (av.id || idx) ? <MinusIcon className="w-3 h-3" /> : <PlusIcon className="w-3 h-3" />}
                                                                                    Avaliação #{idx + 1}
                                                                                </span>
                                                                                <span className={`px-2 py-1 text-xs font-bold rounded ${Number(av.nota_geral) >= 9 ? 'bg-emerald-100 text-emerald-700' : Number(av.nota_geral) >= 7 ? 'bg-blue-100 text-blue-700' : 'bg-red-100 text-red-700'}`}>
                                                                                    Nota: {av.nota_geral}
                                                                                </span>
                                                                            </div>
                                                                            
                                                                            {expandedAssessmentId !== (av.id || idx) && av.comentarios_gerais && (
                                                                                <p className="text-xs text-gray-500 mt-3 italic line-clamp-2">"{av.comentarios_gerais}"</p>
                                                                            )}

                                                                            {expandedAssessmentId === (av.id || idx) && (
                                                                                <div className="mt-4 pt-4 border-t border-gray-100 space-y-2 text-xs">
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-500">Didática:</span> 
                                                                                        <span className="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{av.didatica || '-'}</span>
                                                                                    </div>
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-500">Domínio do Conteúdo:</span> 
                                                                                        <span className="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{av.dominio_conteudo || '-'}</span>
                                                                                    </div>
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-500">Pontualidade:</span> 
                                                                                        <span className="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{av.pontualidade || '-'}</span>
                                                                                    </div>
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-500">Relacionamento:</span> 
                                                                                        <span className="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{av.relacionamento || '-'}</span>
                                                                                    </div>
                                                                                    <div className="flex justify-between items-center">
                                                                                        <span className="text-gray-500">Critérios de Aval.:</span> 
                                                                                        <span className="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{av.criterios_avaliacao || '-'}</span>
                                                                                    </div>
                                                                                    
                                                                                    {av.comentarios_gerais && (
                                                                                        <div className="mt-3 bg-blue-50/50 p-3 rounded-lg border border-blue-100/50">
                                                                                            <span className="block font-bold text-blue-800 mb-1">Comentários:</span>
                                                                                            <p className="text-gray-700 italic">{av.comentarios_gerais}</p>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    )) : <tr><td colSpan={5} className="py-12 text-center text-gray-500 font-medium">Nenhum resultado para os filtros selecionados.</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* ====================== ABA PENDÊNCIAS ====================== */}
                {activeTab === 'pendencias' && (
                    <div className="bg-white rounded-3xl shadow-xl p-8">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-2xl font-bold flex items-center gap-3"><UserGroupIcon /> Cadetes Pendentes</h3>
                            <div className="bg-red-100 text-red-700 px-6 py-2 rounded-2xl font-bold text-lg">{totalPendentes} pendentes</div>
                        </div>

                        {Object.keys(pendenciasAgrupadas).length === 0 ? (
                            <div className="p-12 text-center bg-green-50 rounded-2xl border border-green-200">
                                <p className="text-green-700 font-bold text-2xl">Tudo em dia! 🎉</p>
                            </div>
                        ) : (
                            Object.entries(pendenciasAgrupadas).map(([turma, pelotoesObj]) => {
                                const pelotoesKeys = Object.keys(pelotoesObj).sort();
                                const currentPelotao = selectedPelotaoTab && pelotoesKeys.includes(selectedPelotaoTab) ? selectedPelotaoTab : pelotoesKeys[0];
                                const listaAtual = pelotoesObj[currentPelotao] || [];

                                return (
                                    <div key={turma} className="mb-10 border border-gray-100 rounded-2xl overflow-hidden">
                                        <div className="bg-gray-50 px-6 py-4 font-bold text-lg">{turma}</div>
                                        <div className="p-6">
                                            <div className="flex gap-2 border-b mb-6 overflow-x-auto">
                                                {pelotoesKeys.map(p => (
                                                    <button key={p} onClick={() => setSelectedPelotaoTab(p)}
                                                        className={`px-6 py-2 font-medium border-b-2 transition ${currentPelotao === p ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500'}`}>
                                                        {p}
                                                    </button>
                                                ))}
                                            </div>

                                            <div className="flex justify-between items-center bg-blue-50 p-4 rounded-2xl mb-6">
                                                <div>
                                                    <span className="font-bold text-blue-800">{currentPelotao}</span>
                                                    <span className="ml-3 text-xs bg-red-100 text-red-700 px-3 py-1 rounded-full">{listaAtual.length} pendentes</span>
                                                </div>
                                                <Button onClick={() => handlePrintPendencias(turma, currentPelotao, listaAtual)} variant="outline" className="flex items-center gap-2">
                                                    <PrinterIcon /> Gerar PDF
                                                </Button>
                                            </div>

                                            <div className="overflow-x-auto rounded-xl border">
                                                <table className="min-w-full text-sm">
                                                    <thead className="bg-gray-50">
                                                        <tr><th className="px-6 py-4 text-left">RE</th><th className="px-6 py-4 text-left">Cadete</th><th className="px-6 py-4 text-right">Faltam</th></tr>
                                                    </thead>
                                                    <tbody className="divide-y">
                                                        {listaAtual.map(aluno => (
                                                            <tr key={aluno.id} className="hover:bg-gray-50">
                                                                <td className="px-6 py-4 font-mono text-gray-600">{aluno.re}</td>
                                                                <td className="px-6 py-4 font-medium">{aluno.nome}</td>
                                                                <td className="px-6 py-4 text-right font-bold text-red-600">{aluno.faltam} / {aluno.total}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}
            </div>

            {/* ====================== MODAIS ====================== */}
            
            {/* Modal de Novo Ciclo */}
            <Modal show={showModal} onClose={() => setShowModal(false)} title="Novo Ciclo de Avaliação">
                <form onSubmit={(e) => {
                    e.preventDefault();
                    const temConflito = formCiclo.professores_ids.some(id => 
                        profsOcupadosNoCurso.has(`${id}_${formCiclo.curso_nome}`) || 
                        profsOcupadosNoCurso.has(`${id}_legacy`)
                    );
                    if (temConflito) return alert("Remova os professores que já possuem ciclos abertos para este curso.");
                    handleCreateCiclo(e);
                }} className="space-y-6">
                    <div><label className="block text-sm font-medium mb-1">Título do Ciclo</label>
                        <input value={formCiclo.titulo} onChange={e => setFormCiclo({ ...formCiclo, titulo: e.target.value })} className="w-full border rounded-2xl px-4 py-3" required />
                    </div>

                    <div><label className="block text-sm font-medium mb-1">Curso</label>
                        <select 
                            value={formCiclo.curso_nome} 
                            onChange={e => setFormCiclo({ ...formCiclo, curso_nome: e.target.value, professores_ids: [] })} 
                            className="w-full border rounded-2xl px-4 py-3" 
                            required
                        >
                            <option value="">Selecione o curso para filtrar os professores...</option>
                            {cursosDisponiveis.map(curso => <option key={curso} value={curso}>{curso}</option>)}
                        </select>
                    </div>

                    <div><label className="block text-sm font-medium mb-1">Turma Alvo</label>
                        <select value={formCiclo.turma_id} onChange={e => setFormCiclo({ ...formCiclo, turma_id: e.target.value })} className="w-full border rounded-2xl px-4 py-3" required>
                            <option value="">Selecione...</option>
                            {turmas.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                        </select>
                    </div>
                    
                    <div><label className="block text-sm font-medium mb-1">Professores para Avaliar</label>
                        <div className="max-h-52 overflow-y-auto border rounded-2xl p-4 bg-gray-50 space-y-2">
                            {!formCiclo.curso_nome && (
                                <p className="text-sm text-gray-500 text-center py-4">Selecione um curso acima para ver os professores.</p>
                            )}
                            {formCiclo.curso_nome && professoresFiltrados.length === 0 && (
                                <p className="text-sm text-red-500 text-center py-4">Nenhum professor encontrado dando aula neste curso.</p>
                            )}
                            
                            {professoresFiltrados.map(p => {
                                const materiasDoCurso = p.aulas
                                    .filter(aula => aula.curso_nome === formCiclo.curso_nome)
                                    .map(aula => aula.materia_nome)
                                    .join(' / ');
                                
                                const isOcupado = profsOcupadosNoCurso.has(`${p.id}_${formCiclo.curso_nome}`) || profsOcupadosNoCurso.has(`${p.id}_legacy`);

                                return (
                                    <label key={p.id} className={`flex items-center gap-3 p-3 rounded-xl border transition-all ${isOcupado ? 'bg-gray-200 opacity-60 cursor-not-allowed border-gray-300' : 'cursor-pointer hover:bg-white border-transparent hover:border-gray-200'}`}>
                                        <input type="checkbox" 
                                            checked={formCiclo.professores_ids.includes(p.id)}
                                            disabled={isOcupado} 
                                            onChange={e => {
                                                if (e.target.checked) setFormCiclo(prev => ({ ...prev, professores_ids: [...prev.professores_ids, p.id] }));
                                                else setFormCiclo(prev => ({ ...prev, professores_ids: prev.professores_ids.filter(id => id !== p.id) }));
                                            }} className="w-5 h-5 rounded border-gray-400 text-blue-600 focus:ring-blue-500 disabled:opacity-50" />
                                        
                                        <div className="flex flex-col flex-1">
                                            <span className="font-medium text-gray-900">{p.nome_completo} ({p.posto})</span>
                                            <span className="text-sm text-gray-600">{materiasDoCurso}</span>
                                        </div>

                                        {isOcupado && (
                                            <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded font-bold uppercase tracking-wider">
                                                Em Avaliação
                                            </span>
                                        )}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <Button type="submit" variant="primary" disabled={processing || formCiclo.professores_ids.length === 0}>
                            Criar Ciclo
                        </Button>
                    </div>
                </form>
            </Modal>

            {/* Modal para Expandir Imagem do Professor */}
            {expandedImage && (
                <div 
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" 
                    onClick={() => setExpandedImage(null)}
                >
                    <div className="relative w-full max-w-2xl flex justify-center items-center">
                        <button 
                            className="absolute -top-12 right-0 md:-right-12 text-white hover:text-gray-300 transition-colors p-2"
                            onClick={() => setExpandedImage(null)}
                        >
                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <img 
                            src={expandedImage} 
                            alt="Foto Expandida" 
                            className="rounded-2xl shadow-2xl object-contain max-h-[85vh] w-auto bg-white border-4 border-white"
                            onClick={(e) => e.stopPropagation()} 
                        />
                    </div>
                </div>
            )}

        </div>
    );
};